import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AvailableLangs, TranslocoService } from '@jsverse/transloco';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { Store } from '@ngrx/store';
import { selectUserLanguage } from 'shared/store/user-info/user-info.selector';
import { Lang } from '../../core/transloco/transloco-root.module';
import { saveUserLanguage } from 'shared/store/user-info/user-info.actions';

@Component({
  selector: 'app-default',
  standalone: false,
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.css',
})
export class DefaultLayoutComponent implements OnInit {
  languages = [] as AvailableLangs;

  userLanguage$ = this.store.select(selectUserLanguage);

  constructor(
    private readonly translationService: TranslocoService,
    private readonly localeService: TranslocoLocaleService,
    public router: Router,
    public route: ActivatedRoute,
    private readonly dateAdapter: DateAdapter<Date>,
    private readonly store: Store,
  ) {}

  switchLanguage(value: Lang) {
    this.translationService.load(value).subscribe({
      next: () => {
        this.translationService.setActiveLang(value);

        this.localeService.setLocale(value);
        this.dateAdapter.setLocale(value);
        this.store.dispatch(saveUserLanguage({ language: value }));
      },
      error: (err) => {
        console.error('Failed loading translation', err);
      },
    });
  }

  ngOnInit(): void {
    this.languages = this.translationService.getAvailableLangs();

    // Get user language from store if available, otherwise use default
    this.userLanguage$.subscribe((language) => {
      this.switchLanguage(language ?? Lang.EN_GB);
    });
  }
}
